const actionType = [
    { id: -2, name: 'All', value: 'All' },
    { id: -1, name: 'None', value: 'None' },
    { id: 0, name: 'Fixing', value: 'Fixing' },
    { id: 1, name: 'Fixed', value: 'Fixed' },
];

export { actionType };
